<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrow-back`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.92228 10.1614C5.85787 9.8895 5.93173 9.59146 6.14386 9.37934L12.8221 2.70111C13.1475 2.37567 13.6752 2.37567 14.0006 2.70111C14.326 3.02655 14.326 3.55418 14.0006 3.87962L7.91007 9.97015L14.0016 16.0616C14.327 16.3871 14.327 16.9147 14.0016 17.2401C13.6761 17.5656 13.1485 17.5656 12.823 17.2401L6.14481 10.5619C6.03044 10.4475 5.95627 10.3082 5.92228 10.1614Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowBack',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
